import React, { useState, useEffect } from "react";
import {
  Notifications,
  Place,
  Phone,
  AirlineSeatIndividualSuite,
} from "@mui/icons-material";
import apilink from "../globals/Baseurls";
import axios from "axios";

const Home = () => {
  const [family, setFamily] = useState("");
  const [famcode, setFamilycode] = useState("");
  const [familylevels, setFamilylevels] = useState(1);

  const [famadmin, setFamadmin] = useState("");
  const [adminmail, setAdminmail] = useState("");
  const [adminphone, setAdminphone] = useState("");

  const [members, setMembers] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [slctdMember, setSlctdMember] = useState("");
  const [slctdLevel, setSlctdLevel] = useState("");
  const [slctdNxtLevel, setSlctdNxtLevel] = useState("");

  const [onfilter, setOnfilter] = useState(false);

  // ---------- Styles ----------
  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    gap: 20,
    padding: "20px 0",
    width: "100%",
  };

  const cardStyle = {
    width: 180,
    minWidth: 180,
    height: 350,
    border: "2px solid #a9d5a9",
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    padding: 10,
    backgroundColor: "#f9f9f9",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    cursor: "pointer",
  };

  const imgStyle = {
    width: "100%",
    height: 130,
    borderRadius: 8,
    objectFit: "cover",
    marginBottom: 8,
  };

  const labelStyle = {
    fontSize: 11,
    color: "gray",
  };

  const titleStyle = {
    fontSize: 14,
    fontWeight: "bold",
    color: "#333",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  const badgeStyle = {
    marginTop: -18,
    color: "#779d38",
    alignSelf: "flex-end",
    backgroundColor: "white",
    padding: "4px 8px",
    borderRadius: 10,
    fontSize: 12,
  };

  const infoRowStyle = {
    display: "flex",
    alignItems: "center",
    marginTop: 8,
    gap: 6,
  };

  // ---------- Methods ----------
  const filterArray = async (lvl, id) => {
    let tempArr = [];
    let objIndex = null;

    if (onfilter) {
      tempArr = filtered.filter(
        (item) => !(item.level === lvl && item.id !== id)
      );
      tempArr = tempArr.filter(
        (item) => !(item.level === lvl + 1 && item.parent !== id)
      );
      objIndex = tempArr.findIndex((obj) => obj.id === id);
    } else {
      tempArr = members.filter(
        (item) => !(item.level === lvl && item.id !== id)
      );
      tempArr = tempArr.filter(
        (item) => !(item.level === lvl + 1 && item.parent !== id)
      );
      objIndex = tempArr.findIndex((obj) => obj.id === id);
    }

    tempArr[objIndex].showkids = true;
    setFiltered(tempArr);
    setOnfilter(true);
    setSlctdNxtLevel(parseInt(lvl) + 1);
  };

  const resetFiltering = () => {
    setFiltered(members);
    setOnfilter(false);
    setSlctdNxtLevel("");
  };

  useEffect(() => {
    const getAsyncData = async () => {
      const familyData = JSON.parse(
        localStorage.getItem("userFamilyData")
      );
      const userFamilyLevel = localStorage.getItem("userFamilyLevel");

      setFamily(familyData.record.family);
      setFamilycode(familyData.record.familycode);
      setFamilylevels(userFamilyLevel);

      setFamadmin(familyData.record.alias);
      setAdminmail(familyData.record.email);
      setAdminphone(familyData.record.phone);

      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/members/${familyData.record.familycode}`, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if (response.data.message === "Successfull") {
            setMembers(response.data.records);
            setFiltered(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response?.data?.message || error.message);
        });
    };
    getAsyncData();
  }, []);

  // ---------- Render Levels ----------
  const levelViews = [];

  for (let i = 1; i <= familylevels; i++) {
    const filteredMembers = filtered.filter((item) => item.level === i);

    levelViews.push(
     
      <div key={`level-${i}`} style={containerStyle}>

        {filteredMembers.map((item) => (

          <div
            key={item.id}
            onClick={() => filterArray(item.level, item.id)}
            style={cardStyle}
          >
            <img
              alt={item.alias}
              style={imgStyle}
              src={
                item.img
                  ? `https://treebackend.globalsparks.live/tree-backend/public/images/members/${item.img}`
                  : "https://treebackend.globalsparks.live/tree-backend/public/images/members/temp1.png"
              }
            />

            {item.born && <h6 style={badgeStyle}>{item.born}</h6>}

            <h6 style={titleStyle}>
              {item.alias} {item.surname}
            </h6>
            {item.nickname && <label style={labelStyle}>{item.nickname}</label>}

            {item.parentname && (
              <label style={{ ...labelStyle, marginTop: 4 }}>
                {item.gender === "Male" ? "Son Of" : "Daughter Of"}:{" "}
                {item.parentname}
              </label>
            )}

            <div style={infoRowStyle}>
              <Place style={{ color: "#a9d5a9", fontSize: 24 }} />
              <span style={labelStyle}>{item.residance || "- - -"}</span>
            </div>

            <div style={infoRowStyle}>
              <Phone style={{ color: "#a9d5a9", fontSize: 24 }} />
              <span style={labelStyle}>{item.phone || "- - - - -"}</span>
            </div>

            <div style={infoRowStyle}>
              {item.diedon && (
                <>
                  <AirlineSeatIndividualSuite
                    style={{ color: "#a9d5a9", fontSize: 24 }}
                  />
                  <span style={labelStyle}>{item.diedon}</span>
                </>
              )}
              {item.showkids && onfilter && (
                <img
                  alt="arrow"
                  style={{ width: 30, height: 30, marginLeft: "auto" }}
                  src={require("./arrow.webp")}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <p style={{ fontFamily: "Open Sans", fontSize: 14, margin: 0 }}>
          {family} Family
        </p>
        <span style={{ fontFamily: "Open Sans" }}>{famcode}</span>
      </div>

      {/* Controls */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <button
          onClick={resetFiltering}
          style={{
            backgroundColor: onfilter ? "green" : "gray",
            color: "white",
            border: "none",
            borderRadius: 4,
            padding: "6px 12px",
            cursor: "pointer",
          }}
        >
          Reset
        </button>

        <div style={{ position: "relative" }}>
          <Notifications style={{ color: "#000000", fontSize: 30 }} />
          <span
            style={{
              padding: 2,
              backgroundColor: "red",
              borderRadius: 10,
              width: 12,
              height: 12,
              position: "absolute",
              top: -5,
              left: 20,
            }}
          ></span>
        </div>
      </div>

      {/* Members */}
      <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
        {levelViews}
      </div>
    </>
  );
};

export default Home;
